import request from "@/utils/request";

export function list(data) {
  return request({
    url: "/business/staff/list",
    method: "post",
    data
  });
}

export function create(data) {
  return request({
    url: "/business/staff/add",
    method: "post",
    data
  });
}

export function info(data) {
  return request({
    url: "/business/staff/infoById",
    method: "get",
    params: data
  });
}

export function update(data) {
  return request({
    url: "/business/staff/update",
    method: "put",
    data: data
  });
}

export function del(data) {
  return request({
    url: "/business/staff/delete",
    method: "delete",
    params: data
  });
}

export function reset(data) {
  return request({
    url: "/business/staff/reset",
    method: "put",
    data: data
  });
}

export function feeRefundList(data) {
  return request({
    url: "/business/business/businessFeeRefundList",
    method: "post",
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/agency.js